import InfoBox from "../../ui/InfoBox"
import SectionHeader from "../../ui/SectionHeader"
import { FiHash } from "react-icons/fi"
import { useResetListener } from "../../../hooks/useResetListener"

interface ReferenceNumberSectionProps {
  value: string
  onChange: (value: string) => void
  disabled?: boolean
}

export default function ReferenceNumberSection({
  value,
  onChange,
  disabled = false
}: ReferenceNumberSectionProps) {

  useResetListener(() => {
    onChange("")
  })

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!disabled) {
      onChange(e.target.value)
    }
  }

  return (
    <div>
      <SectionHeader icon={<FiHash size={20} />} title="Personal reference number">
        <InfoBox title="Format requirements">
          It should consist of up to 30 alphanumeric characters and certain
          special characters (A–Z, a–z, 0–9, /, -, .). Blank spaces not allowed.
        </InfoBox>
      </SectionHeader>

      <input
        type="text"
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={`w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-1 focus:ring-orange-400 ${disabled ? "bg-gray-100 cursor-not-allowed" : ""}`}
        placeholder="Enter your personal reference"
      />
    </div>
  )
}
